import * as React from 'react';
import { FormGroup as MuiFormGroup } from '@material-ui/core';

var FormGroup = function FormGroup(_ref) {
  var getBodySlot = _ref.getBodySlot,
      body = _ref.body,
      children = _ref.children,
      row = _ref.row;
  var bodyCb = React.useCallback(function (node) {
    getBodySlot && getBodySlot(node);
  }, [getBodySlot]);
  return /*#__PURE__*/React.createElement(MuiFormGroup, {
    row: row,
    ref: bodyCb
  }, body, children);
};

export default FormGroup;

try {
  FormGroup.__docgenInfo = {
    description: '',
    displayName: 'FormGroup',
    methods: [],
    props: {
      body: {
        defaultValue: null,
        description: '',
        name: 'body',
        required: false,
        type: {
          name: 'ReactNode'
        }
      },
      getBodySlot: {
        defaultValue: null,
        description: '',
        name: 'getBodySlot',
        required: false,
        type: {
          name: '(elem: HTMLElement) => any'
        }
      },
      row: {
        defaultValue: null,
        description: 'Display group of elements in a compact row.',
        name: 'row',
        required: false,
        type: {
          name: 'boolean'
        }
      }
    }
  };
} catch (e) {}
//# sourceMappingURL=index.js.map